<div
  class="bg-slate-800 bg-opacity-50 dark:bg-opacity-70 flex justify-center items-center fixed top-0 right-0 bottom-0 left-0 z-50">
  <div class="bg-gradient-to-bl bg-dark-khaki-50 dark:bg-vivid-royal-950 px-16 py-14 w-2/3 md:w-full md:max-w-md rounded-2xl text-center relative" (appOutsideClick)="clickOutside($event)">
    @if (showIcon) {


    <h1 class="text-xl mx-auto text-center mb-5"
      [ngClass]="{'text-green':isSuccess,'dark:text-red-400 text-red-400':!isSuccess}">
      @if(isSuccess){
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12 mx-auto"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>
      }@else {
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12 mx-auto"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>
      }


    </h1>
    }

    @if(isHtml){
    <p [innerHTML]="message | parserHtml " class="text-lg mb-4 font-medium text-medium_purple dark:text-dark-khaki-50"> </p>
    }@else{
    <p class="text-lg mb-4 font-medium text-medium_purple dark:text-dark-khaki-50"> {{message}}</p>
    }

    @if(hasButtons){
    <div class="flex justify-between">
      <button
        class="px-3 py-1 bg-orange_light text-medium_purple  rounded-md w-full sm:w-auto text-sm font-semibold disabled:bg-zinc-400 disabled:text-zinc-800/60"
        type="button" (click)="cancelAction()">{{txtCancelButton}}</button>
        <button
        class="px-3 py-1 bg-orange_light text-medium_purple  rounded-md w-full sm:w-auto text-sm font-semibold disabled:bg-zinc-400 disabled:text-zinc-800/60"
        type="button" (click)="confirmAction()">{{txtConfirmButton}}</button>
    </div>
    }


    <button
      class="absolute top-2 right-2 dark:text-dark-khaki-50  text-medium_purple hover:dark:text-zinc-400 hover:text-vivid-royal-950"
      (click)="cancelAction()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    </button>
  </div>
</div>
